// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U4r-E","type":"styles_type__2nAit","choices":"styles_choices__2grfm"};